<div class="absolute" style="top: -3rem;">
    <p-dropdown
        [options]="projects"
        [(ngModel)]="selectedProject"
        placeholder="Project"
        (onChange)="onProjectSelection()"/>
</div>
<div id="kanban-wrapper" cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="dropList($event)"
     [cdkDropListData]="lists"
     class="grid grid-nogutter gap-3 w-full flex-column md:flex-row flex-nowrap lg:overflow-y-hidden overflow-x-scroll">
    <app-kanban-list *ngFor="let list of lists; let i = index;" [list]="list" [listIds]="listIds" cdkDrag cdkDragHandle
                     [cdkDragDisabled]="isMobileDevice" class="p-kanban-list md:col-2 border-bottom-3 border-blue-200 md:border-none pb-3 md:pb-0"></app-kanban-list>
    <div class="px-3 py-1 mb-3 flex-shrink-0">
        <button pButton pRipple label="New List" icon="pi pi-plus font-semibold"
                class="py-3 justify-content-center font-semibold border-round" (click)="addList()"></button>
    </div>
    <app-kanban-sidebar></app-kanban-sidebar>
</div>
